import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLogin: false,
  isPortal: false
}

const loginSlices = createSlice({
  name: "login",
  initialState: initialState,
  reducers:{
    login(state){
      state.isLogin = true;
      state.isPortal = true;
    },
    portal(state){
      state.isLogin = false;
    }
  }
});

export const loginActions = loginSlices.actions;
export default loginSlices.reducer;